var go = require('gojs');
var edit = require('../../../../../layout/components/edit');
var diagramConfiguration = require('../../diagramConfiguration');
var maxSafeBodyDimension = 1000000;

function getResizeCellSize() {
  return new go.Size(
    diagramConfiguration.calculateCellWidth(),
    diagramConfiguration.calculateCellHeight()
  );
}

function getBodySize(data) {
  var width = Number(data && data.width);
  var height = Number(data && data.height);

  if (hasStoredBodySize(data)) {
    return new go.Size(width, height);
  }
  return new go.Size(NaN, NaN);
}

function hasStoredBodySize(data) {
  var width = Number(data && data.width);
  var height = Number(data && data.height);

  return Number.isFinite(width) &&
    width > 0 &&
    width <= maxSafeBodyDimension &&
    Number.isFinite(height) &&
    height > 0 &&
    height <= maxSafeBodyDimension;
}

function createSizedVisibilityBinding(visibleWhenSized) {
  return new go.Binding('visible', '', function(data) {
    return hasStoredBodySize(data) === visibleWhenSized;
  });
}

function createSizedNameBinding(name, namedWhenSized) {
  return new go.Binding('name', '', function(data) {
    return hasStoredBodySize(data) === namedWhenSized ? name : '';
  });
}

function createResizableBinding() {
  return new go.Binding('resizable', '', function() {
    return edit.vm.editing();
  });
}

function createBodySizeBindings() {
  return [
    new go.Binding('desiredSize', '', getBodySize)
  ];
}

module.exports = {
  createBodySizeBindings,
  createResizableBinding,
  createSizedNameBinding,
  createSizedVisibilityBinding,
  getResizeCellSize
};
